const state = {
  token: null,
  authedAcct: null,
  users: [],
  lists: [],
  page: 1
}

export default state
